<template>
  <Tabbar v-model="active" :safe-area-inset-bottom="true" active-color="#aa341b" @change="changeTab">
    <TabbarItem name="overview">
      <span>{{ $t('ga_admin_tab_overview') }}</span>
      <template #icon="{ active }">
        <van-icon :name="active ? 'wap-home' : 'wap-home-o'" />
      </template>
    </TabbarItem>
    <TabbarItem name="customers">
      <span>{{ $t('ga_admin_tab_customers') }}</span>
      <template #icon="{ active }">
        <van-icon :name="active ? 'friends' : 'friends-o'" />
      </template>
    </TabbarItem>
    <TabbarItem v-if="showAIAssistant" name="ai" class="ai-tab-item">
      <template #icon="{ active }">
        <div class="ai-icon-wrapper">
          <font-awesome-icon :icon="[active ? 'fas' : 'far', 'lightbulb']" class="ai-icon" />
        </div>
      </template>
      <span>{{ $t('ga_admin_tab_ai') }}</span>
    </TabbarItem>
    <TabbarItem name="execution">
      <span>{{ $t('ga_admin_tab_execution') }}</span>
      <template #icon="{ active }">
        <font-awesome-icon :icon="['fas', 'tasks']" :class="['custom-icon', { active }]" />
      </template>
    </TabbarItem>
    <TabbarItem name="strategy">
      <span>{{ $t('ga_admin_tab_strategy') }}</span>
      <template #icon="{ active }">
        <font-awesome-icon :icon="['fas', 'flag']" :class="['custom-icon', { active }]" />
      </template>
    </TabbarItem>
  </Tabbar>
</template>

<script>
import { Tabbar, TabbarItem, Icon } from 'vant';
import { isEnableAI } from '@/utils/index';

export default {
  name: 'GAAdminTabBar',
  components: {
    Tabbar,
    TabbarItem,
    vanIcon: Icon,
  },
  data() {
    return {
      active: 'overview',
      showAIAssistant: isEnableAI(),
    };
  },
  created() {
    this.updateActiveTab(this.$route.name);
    this.showAIAssistant = isEnableAI();
    this.$router.afterEach((to) => {
      this.updateActiveTab(to.name);
    });
  },
  methods: {
    updateActiveTab(routeName) {
      switch (routeName) {
        case 'gaAdminOverview':
          this.active = 'overview';
          break;
        case 'gaAdminCustomers':
          this.active = 'customers';
          break;
        case 'gaAdminExecution':
          this.active = 'execution';
          break;
        case 'gaAdminStrategy':
          this.active = 'strategy';
          break;
        default:
          this.active = 'overview';
          break;
      }
    },
    changeTab(tab) {
      switch (tab) {
        case 'overview':
          this.$router.push({ path: '/ga-admin/overview' });
          break;
        case 'customers':
          this.$router.push({ path: '/ga-admin/customers' });
          break;
        case 'ai':
          this.$root.$emit('open-ai-chat', undefined, false, 'SRCopilotInsightGBA');
          this.$nextTick(() => {
            this.updateActiveTab(this.$route.name);
          });
          break;
        case 'execution':
          this.$router.push({ path: '/ga-admin/execution' });
          break;
        case 'strategy':
          this.$router.push({ path: '/ga-admin/strategy' });
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .van-tabbar__item--active {
    color: #aa341b;
  }

  .van-tabbar-item__text {
    font-size: 10px;
  }

  .ai-tab-item {
    .van-tabbar-item__text {
      font-size: 9px;
      transform-origin: center top;
      margin-top: -10px;
      display: inline-block;
    }

    .van-tabbar-item__icon {
      margin-bottom: 0;
      height: 48px;
    }
  }
}

.custom-icon {
  font-size: 18px;
  color: #7d7e80;
}

.custom-icon.active {
  color: #aa341b;
}

.ai-icon-wrapper {
  position: absolute;
  top: -20px;
  left: 50%;
  transform: translateX(-50%);
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: linear-gradient(135deg, #4d50e9, #b84fd7, #aa341b);
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.12);
  border: 4px solid #fff;
  z-index: 10;
}

.ai-icon {
  color: #fff;
  font-size: 20px;
}
</style>
